export const GROUPER_FORMULA_MODES = ['raw', 'simple', 'advanced']
